document.addEventListener('click', function(event) {
  var link = event.target.closest('a[href^="#"]');
  if (!link) return;
  var hash = link.getAttribute('href');
  if (!hash || hash === '#') return;
  var target = document.getElementById(hash.slice(1));
  if (!target) {
    if (hash === '#buy' || hash === '#how-to-play') { event.preventDefault(); window.location.assign('/' + hash); }
    return;
  }
  event.preventDefault();
  if (hash === '#buy' && window.matchMedia('(max-width: 800px)').matches) {
    var carousel = target.querySelector('.pf-offers');
    if (carousel) {
      var bounds = carousel.getBoundingClientRect();
      var center = bounds.left + bounds.width / 2;
      var cards = Array.from(carousel.querySelectorAll('.pf-offer'));
      var card = cards.reduce(function(best, item) {
        var r = item.getBoundingClientRect();
        var b = best && best.getBoundingClientRect();
        return !b || Math.abs(r.left + r.width / 2 - center) < Math.abs(b.left + b.width / 2 - center) ? item : best;
      }, null);
      if (card) {
        var viewport = window.visualViewport;
        var top = viewport ? viewport.offsetTop : 0;
        var bottom = top + (viewport ? viewport.height : window.innerHeight);
        // Account for the Shopify draft toolbar when it overlays the viewport.
        var previewBar = document.getElementById('PBarNextFrame');
        if (previewBar) {
          var bar = previewBar.getBoundingClientRect();
          if (bar.height > 0 && bar.top > top && bar.top < bottom) bottom = bar.top;
        }
        var rect = card.getBoundingClientRect();
        var space = Math.max(16, (bottom - top - rect.height) / 2);
        window.scrollTo({ top: Math.max(0, window.scrollY + rect.top - top - space), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        return;
      }
    }
  }
  var header = document.querySelector('.main-header-wrapper');
  var offset = header ? header.getBoundingClientRect().height : 0;
  window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - offset - 16, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
});
